import { useEffect, useState } from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  MenuItem,
  Stack,
  TextField,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import GameRating from './GameRating';

const EditShelfEntryDialog = ({ game, open, onClose, onSave, isSaving = false }) => {
  const { t } = useTranslation();
  const [values, setValues] = useState({
    personalRating: null,
    ownershipStatus: 'owned',
    notes: '',
  });

  useEffect(() => {
    setValues({
      personalRating: game?.personalRating || null,
      ownershipStatus: game?.ownershipStatus || 'owned',
      notes: game?.notes || '',
    });
  }, [game]);

  const handleChange = (field) => (event) => {
    setValues((current) => ({ ...current, [field]: event.target.value }));
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>{t('games.edit.title')}</DialogTitle>
      <DialogContent dividers>
        <Stack spacing={2.5} sx={{ pt: 1 }}>
          <GameRating
            value={values.personalRating}
            onChange={(personalRating) =>
              setValues((current) => ({ ...current, personalRating }))
            }
          />
          <TextField
            select
            label={t('games.edit.statusLabel')}
            value={values.ownershipStatus}
            onChange={handleChange('ownershipStatus')}
          >
            <MenuItem value="owned">{t('games.edit.statusOwned')}</MenuItem>
            <MenuItem value="wishlist">{t('games.edit.statusWishlist')}</MenuItem>
            <MenuItem value="played">{t('games.edit.statusPlayedElsewhere')}</MenuItem>
          </TextField>
          <TextField
            label={t('games.edit.noteLabel')}
            multiline
            minRows={3}
            value={values.notes}
            onChange={handleChange('notes')}
            placeholder={t('games.edit.notePlaceholder')}
          />
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{t('common.cancel')}</Button>
        <Button variant="contained" disabled={isSaving} onClick={() => onSave(values)}>
          {t('common.save')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EditShelfEntryDialog;
